//
// JAlert.js
//

class JAlert {
    constructor(data) {
        this._data = data?.JTurn?.JAlert ?? {};
    }

    createElement(options) {
        const {message, type, dismissible} = options;

        const alert = document.createElement('div');
        alert.classList.add('alert', 'alert-' + type);
        alert.setAttribute('role', 'alert');

        alert.innerHTML = message;

        if (dismissible) {
            const button = document.createElement('button');
            button.classList.add('btn-close');
            button.type = 'button';
            button.setAttribute('data-bs-dismiss', 'alert');
            button.setAttribute('aria-label', 'Fechar');

            alert.classList.add('alert-dismissible', 'fade', 'show');
            alert.appendChild(button);
        }

        return alert;
    }

    run() {
        for (const selector in this._data) {
            for (const wrapper of document.querySelectorAll(selector)) {
                wrapper.innerHTML = '';

                for (const options of this._data[selector]) {
                    wrapper.appendChild(this.createElement(options));
                }
            }
        }
    }
}

// Make available globally
window.JAlert = JAlert;